export {
  default as playground,
  ReactComponent as Playground,
} from '@assets/icons/features-and-amenities/playground.svg'    
